// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { TypesServiceService } from '../../types-service.service';
import { GetTypesService } from './types-service.actions';
import { TYPES_SERVICE_STATE_DEFAULT, TypesServiceStateModel } from './types-service.model';

@State({ name: 'TypesService', defaults: TYPES_SERVICE_STATE_DEFAULT })
@Injectable()
export class TypesServiceState {

  constructor(private service: TypesServiceService) {
  }

  @Selector()
  static typesService(state: TypesServiceStateModel): TypesServiceStateModel['typesService'] {
    return state.typesService;
  }

  @Selector()
  static loadTypesServiceStatus(state: TypesServiceStateModel): TypesServiceStateModel['loadTypesServiceStatus'] {
    return state.loadTypesServiceStatus;
  }

  @Action(GetTypesService)
  getTypesService(ctx: StateContext<TypesServiceStateModel>): void {
    ctx.patchState({
      loadTypesServiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getTypesServices()
      .subscribe({
        next: (typesService) => {
          ctx.patchState({
            typesService,
            loadTypesServiceStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadTypesServiceStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }
}


